import * as React from 'react'
import { SavedImage } from './useSaveImage'

interface UseImageUploadProps {
	saveImage: (params: { url: string; width: number; height: number }) => SavedImage
	initializeDimensionImages: (params: { url: string; width: number; height: number }) => void
}

interface UseImageUploadResult {
	handleImageUpload: (file: File) => void
}

export const useImageUpload = ({ saveImage, initializeDimensionImages }: UseImageUploadProps): UseImageUploadResult => {
	const handleImageUpload = React.useCallback(
		(file: File) => {
			// Create a URL for the uploaded file
			const fileUrl = URL.createObjectURL(file)

			// Load the image to get its dimensions
			const img = new Image()
			img.onload = () => {
				// Save the uploaded image
				const savedImage = saveImage({
					url: fileUrl,
					width: img.width,
					height: img.height,
				})

				// Initialize dimension images with the uploaded image
				initializeDimensionImages({
					url: savedImage.url,
					width: savedImage.width,
					height: savedImage.height,
				})
			}
			img.src = fileUrl
		},
		[saveImage, initializeDimensionImages],
	)

	return { handleImageUpload }
}
